"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorPicker = void 0;
var react_1 = __importDefault(require("react"));
var react_color_1 = require("react-color");
var ColorPicker = function (_a) {
    var value = _a.value, onChange = _a.onChange, colors = _a.colors;
    return (react_1.default.createElement(react_color_1.TwitterPicker, { colors: colors !== null && colors !== void 0 ? colors : [
            "#000000",
            "#ffffff",
            "#FF6900",
            "#FCB900",
            "#00D084",
            "#0693E3",
            "#ABB8C3",
            "#EB144C",
            "#F78DA7",
            "#9900EF",
        ], color: value, onChange: function (c) { return onChange === null || onChange === void 0 ? void 0 : onChange(c.hex); }, width: "192px", styles: {
            default: {
                body: {
                    width: 192,
                    paddingTop: 8,
                    paddingLeft: 8,
                    paddingRight: 2,
                    paddingBottom: 2,
                },
                swatch: {
                    width: 20,
                    height: 20,
                    boxShadow: "rgb(0 0 0 / 25%) 0px 1px 4px",
                },
                input: {
                    height: 20,
                    width: 58,
                },
                label: {
                    height: 20,
                },
                hash: {
                    height: 22,
                },
            },
        }, triangle: "hide" }));
};
exports.ColorPicker = ColorPicker;
